import PropTypes from 'prop-types';
import React from 'react';
import map from 'lodash/map';
import compact from 'lodash/compact';

import { fullName } from '../../../common/helpers/users';

const CustomerListItem = ({ customer, barber }) => (
  <li>
    {compact([
      fullName(customer),
      customer.phone,
      customer.email,
      map(customer.services, 'name').join(', '),
      barber,
    ]).join(', ')}
  </li>
);
CustomerListItem.propTypes = {
  customer: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }).isRequired,
  barber: PropTypes.string,
};
CustomerListItem.defaultProps = {
  barber: null,
};

export default CustomerListItem;
